<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text External Form Template
    v-row
      v-col(cols="6")
        v-text-field(
          v-model="instance.expirationTimeExpression",
          :label="$t('ActionTemplate.expirationTime')"
        )
      v-col(cols="6")
        v-text-field(
          v-model="instance.externalType",
          :label="$t('ActionTemplate.externalType')"
        )
    code-editor(
      v-model="instance.body",
      language="htmlembedded"
    )
    v-row
      v-col(cols="12")
        h3 Metadata
        v-jsoneditor(
          v-model="instance.metadata",
          :plus="false",
          :options="editorOptions",
          @error="onError",
        )
</template>

<style type="text/css">
span.text-size{
  overflow: hidden;
}
</style>

<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  props: ['value'],
  components: {
    VJsoneditor,
  },
  data: function ()  {
    return {
      initObject: {
        type: 'External Form',
        body: '',
        expirationTimeExpression: null,
        externalType: null,
        isRazor: true,
        metadata: {},
      },
      instance: {},
    }
  },
  computed: {
    editorOptions() {
      return {
        modes: ['tree','text'],
        enableSort: false,
        name: "metadata",
      }
    }
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onError(e) {
      console.log('error', e);
    },
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
